(function () {
  "use strict";
  const templateSelector = "[data-video-template]",
    loadingClass = "is-loading",
    idAttr = "data-video-id";

  if (customElements.get("video-background")) return;

  customElements.define(
    "video-background",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.videoId = this.getAttribute(idAttr);
        this.videoTemplate = this.querySelector(templateSelector);
        this.video = null;
        if (this.videoId) this.initControls();
      }
      initControls() {
        const section = this.closest('[data-section-id]') || this.parentElement;
        if (section) {
          const playBtn = section.querySelector('.video-play-pause-toggle');
          if (playBtn) {
            playBtn.classList.add('is-visible');
            playBtn.classList.add('is-paused');
          }
        }
      }
      playVideo() {
        if (!this.video) {
          const templateHtml = this.videoTemplate ? this.videoTemplate.innerHTML : "";
          if (templateHtml) {
            this.innerHTML = templateHtml;
            this.classList.remove(loadingClass);
            this.video = this.querySelector("video");
          }
        }
        if (this.video && typeof this.video.play === "function") {
          this.video.muted = true;
          this.video.setAttribute("playsinline", "true");
          this.video.setAttribute("webkit-playsinline", "true");
          return this.video.play();
        }
        return Promise.reject();
      }
      pauseVideo() {
        if (this.video && typeof this.video.pause === "function") {
          this.video.pause();
        }
      }
      disconnectedCallback() {}
    }
  );
})();
